import axios from '@/libs/axios'
import { ApiCode, ApiExtRoutes } from '@/const/api'
import { handleCatch } from '@/utils'

export default {
  namespaced: true,
  state: {
    dataLists: [],
    allSemesters: [],
    allTrainingSystems: [],
    listTrainingSystemCourses: [],
    listCourseMajors: [],
    listCourseMajorClasses: [],
    subjects: [],
    creditClasses: [],
  },
  getters: {
    dataLists: state => state.dataLists,
    allSemesters: state => state.allSemesters,
    allTrainingSystems: state => state.allTrainingSystems,
    listTrainingSystemCourses: state => state.listTrainingSystemCourses,
    listCourseMajors: state => state.listCourseMajors,
    listCourseMajorClasses: state => state.listCourseMajorClasses,
    subjects: state => state.subjects,
    creditClasses: state => state.creditClasses,
  },
  mutations: {
    SET_ALL: (state, { dataTrainingSystem, dataSemester }) => {
      state.allTrainingSystems = dataTrainingSystem
      state.allSemesters = dataSemester
    },
    SET_LISTTRAININGSYSTEMCOURSES: (state, { data }) => {
      state.listTrainingSystemCourses = data
    },
    SET_LISTCOURSEMAJORS: (state, { data }) => {
      state.listCourseMajors = data
    },
    SET_LISTCOURSEMAJORCLASSES: (state, { data }) => {
      state.listCourseMajorClasses = data
    },
    SET_DATA: (state, { data }) => {
      state.dataLists = data
    },
    SET_SUBJECTS: (state, data) => { state.subjects = data },
    SET_CREDIT_CLASSES: (state, data) => { state.creditClasses = data },
  },
  actions: {
    async getData({ commit }, params) {
      try {
        const response = await axios.get('uni/reports/reportClassReceiptCourseSemester', { params })
        if (response.data.code === ApiCode.SUCCESS) {
          commit('SET_DATA', {
            data: response.data.data,
          })
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async begin({ commit }) {
      try {
        const rsTrainingSystem = await axios.get('uni/exemptions/training_systems')
        const rsSemester = await axios.get('uni/reports/reportClassReceiptCourseSemester/semesters')
        if (rsTrainingSystem.data.code === ApiCode.SUCCESS && rsSemester.data.code === ApiCode.SUCCESS) {
          commit('SET_ALL', {
            dataTrainingSystem: rsTrainingSystem.data.data.rs,
            dataSemester: rsSemester.data.data.data,
          })
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async getListTrainingSystemCourses({ commit }, params) {
      try {
        const response = await axios.get('uni/exemptions/courses', { params })
        if (response.data.code === ApiCode.SUCCESS) {
          commit('SET_LISTTRAININGSYSTEMCOURSES', {
            data: response.data.data.rs,
          })
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async getListCourseMajors({ commit }, params) {
      try {
        const response = await axios.get('uni/reports/reportAvgStudentClass/selectCoursesMajors', { params })
        if (response.data.code === ApiCode.SUCCESS) {
          commit('SET_LISTCOURSEMAJORS', {
            data: response.data.data.rs,
          })
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async getListCourseMajorClasses({ commit }, params) {
      try {
        const response = await axios.get('uni/reports/reportAvgStudentClass/selectCoursesMajorsClasses', { params })
        if (response.data.code === ApiCode.SUCCESS) {
          commit('SET_LISTCOURSEMAJORCLASSES', {
            data: response.data.data.rs,
          })
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async getSubjectsBySemesterIdAndCourseId({ commit }, params) {
      try {
        const response = await axios.get('uni/subjects/getSubjectsBySemesterIdAndCourseId', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_SUBJECTS', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async getCreditClassesByCourseSemesterAndSubject({ commit }, params) {
      try {
        const response = await axios.get('uni/credit_classes/getCreditClassByCourseAndSemesterAndSubject', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_CREDIT_CLASSES', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async downloadPdf({ commit }, params) {
      try {
        const response = await axios({
          method: 'get',
          url: 'uni/reports/reportClassReceiptCourseSemesterExport',
          responseType: 'blob',
          params,
        })
        return response.data
      } catch (e) {
        handleCatch(e)
      }
    },
  },
}
